<script lang="ts"></script>

<style lang="scss">
  :host {
    display: inline-block;
  }
</style>
